import { useSyncExternalStore } from "react"

const state = { value: 0 }
const listeners = new Set<()=> void>()

export function setDatabaseLength(next: number) {
  if (next === state.value) return
  state.value = next
  for (const listener of listeners) {
    listener()
  }
}

export function useDatabaseLength() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}

function getSnapshot() {
  return state.value
}

function subscribe(listener: ()=> void) {
  listeners.add(listener)
  return ()=> {
    listeners.delete(listener)
  }
}
